import { render } from "./AudioRecorder.vue?vue&type=template&id=5bf14960"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src204698009/src/soutio-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__